import Header from "./components/Header/Header";
import AppContent from "./components/Content/AppContent";
import React, { useRef, useState} from "react";
import Modal from "./components/Modal/Modal";
import OrderRentModal from "./components/Modal/OrderRentModal";
import Close from "./images/Close.png";
import SuccessfulOrder from "./components/Modal/SuccessfulOrder";
import consoleDetails from "./utils/consoles";
import ConsoleModal from "./components/Modal/ConsoleModal";
import ScrollToTop from "./utils/ScrollToTop";
import Fullscreen from "./components/Modal/Fullscreen";
import FullScreenModal from "./components/Modal/FullScreenModal";
import {Route, Routes} from "react-router-dom";
import Privacy from "./utils/Privacy";
import ScrollToHash from "./utils/ScrollToHash";



function App() {
    const modal = useRef()
    const catalogModal = useRef()
    const consoleDialogRef = useRef();
    const fullScreenModalRef = useRef();
    const [showNotification, setShowNotification] = useState(false);
    const [selectedConsole, setSelectedConsole] = useState(null)
    const [isVisibleDetails, setIsVisibleDetails] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(null);
    const [rentDays, setRentDays] = useState(1)

    const handleRentDaysChange = (days) => {
        setRentDays(days)
    }

    function handleOpenModal() {
        modal.current.open()
    }
    function handleCloseModalBtn() {
        modal.current.close()
    }
    function handleCloseModal() {
        modal.current.close()
    }

    const handleOrderSuccess = () => {
        setShowNotification(true);
    };
    const closeNotification = () => {
        setShowNotification(false);
    };

    const handleSelectConsole = (consoleId) => {
        setSelectedConsole(null);
        setTimeout(() => {
            const selected = consoleDetails.find((console) => console.id === consoleId);
            setSelectedConsole(selected);
            consoleDialogRef.current.open();
            // Push modal_open event to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'rental_card',
            });
            console.log("Event 'rental_card' has been pushed");
        }, 0);
    };
    const handleCloseConsoleModal = () => {
        consoleDialogRef.current.close()
        setIsVisibleDetails(false)
    }
    const handleVisibleDetails = () => {
        setIsVisibleDetails(!isVisibleDetails)
    }

    const openFullscreen = (index) => {
        setCurrentImageIndex(index);
        setIsFullscreen(true);
    };
    const closeFullscreen = () => {
        setIsFullscreen(false);
        setCurrentImageIndex(null);
        fullScreenModalRef.current.close();
    };
    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % selectedConsole.image.length);
    };
    const prevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            (prevIndex - 1 + selectedConsole.image.length) % selectedConsole.image.length
        );
    };
    const handleOpenFullscreenModal = () => {
        fullScreenModalRef.current.open()
    }


    return (
        <Routes>
            <Route path="/" element={
                <div className="App">
                    <ScrollToHash />
                    {showNotification && (
                        <SuccessfulOrder onClose={closeNotification} />
                    )}
                    <Modal ref={modal}>
                        <OrderRentModal
                            rentDays={rentDays}
                            KIT={selectedConsole?.KIT || "DEFAULT"}
                            openSuccessful={handleOrderSuccess}
                            closeModal={handleCloseModal}
                            modalRef={modal}
                        />
                    </Modal>
                    <Modal ref={consoleDialogRef} onClose={() => setIsVisibleDetails(false)}>
                        <div className='close-btn'>
                            <button onClick={() => handleCloseConsoleModal()}><img src={Close} alt=""/></button>
                        </div>
                        <ConsoleModal
                            isVisible={isVisibleDetails}
                            visibleDetails={handleVisibleDetails}
                            openModal={handleOpenModal}
                            closeConsoleModal={handleCloseConsoleModal}
                            selectedConsole={selectedConsole}
                            openFullscreen={openFullscreen}
                            openFullscreenModal={handleOpenFullscreenModal}
                            rentDaysChange={handleRentDaysChange}
                        />
                    </Modal>
                    <Header openModal={handleOpenModal}/>
                    <AppContent
                        selectConsole={handleSelectConsole}
                        openModal={handleOpenModal}
                    />
                    <ScrollToTop/>
                    <FullScreenModal ref={fullScreenModalRef}>
                        <Fullscreen
                            closeFullscreen={closeFullscreen}
                            selectedConsole={selectedConsole}
                            currentImageIndex={currentImageIndex}
                            nextImage={nextImage}
                            prevImage={prevImage}
                            isFullscreen={isFullscreen}
                        />
                    </FullScreenModal>
                </div>
            } />
            <Route path="/privacy" element={<Privacy/>} />
        </Routes>
    );
}

export default App;
